


<div class="col-md-12 main" *ngIf="travellerDetail" >
    <div class="outside-container mt-4">
        <div class="box-container ">
          <div *ngIf="userType==='STAFF'" class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
            First, emulate the user,  <mat-icon style="width: 50px;" class="pointer">forward</mat-icon> and then proceed to the booking page    
    
          </div>
            <div *ngIf="userType!='STAFF'" class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
              <div *ngIf="swingGenerate" class=" col-md-12 gif-container">  <img   src="../../../assets/images/image_processing20210217-16671-11ezcsw.gif" alt=""    >  </div> 
              
                <div *ngIf="!swingGenerate" class="col-md-12 row">
                <div *ngIf="!paymentDetail" class="col-md-9" style=" height:85vh;overflow-y: auto;">
              <mat-stepper orientation="vertical" [linear]="true" #stepper>
                <mat-step [stepControl]="firstFormGroup">
                  <form [formGroup]="firstFormGroup">
                    <ng-template matStepLabel>
                        {{hotelDetail.name}} 
                        <small *ngFor="let start of starArray(hotelDetail.starRating)"> 
                            <img  src="../../../assets/images/star.png" width="18" height="18" alt="">
                            </small>
                        
                    </ng-template>

                        <div class="hotel-details">
                        <p>
                            {{hotelDetail?.location}} 
                              Postal Code: {{hotelDetail?.pinCode}}</p>
                            <!-- <a href="#" class="back-link">Back to hotel details</a> -->
                            <div class="details">
                              <div class="detail">
                                <h2>Check In</h2>
                                <p>{{searchDetail?.checkInDate}}</p>
                              </div>
                              <div class="detail">
                                <h2>Check Out</h2>
                                <p>{{searchDetail?.checkOutDate}}</p>

                              </div>
                              <div class="detail">
                                <h2>Total Rooms</h2>
                                <p>{{searchDetail?.roomCount}}</p>
                              </div>
                              <div class="detail">
                                <h2>Total Guest</h2>
                                <p>{{searchDetail?.adultCount+searchDetail?.childCount}}</p>
                              </div>
                            </div>
                          </div>


                      



                    
                    <mat-divider class="mt-4"></mat-divider>
                    <div class="mt-3">
                      <button *ngIf="!swingGenerate" mat-raised-button color="accent" (click)="onItineraryClick()" matStepperNext>Continue</button>
                      <button  *ngIf="swingGenerate"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                    </div>
                  </form>
                  
                </mat-step>
                <mat-step [stepControl]="secondFormGroup" >
                  <ng-template matStepLabel >Add Guest details</ng-template>
                  <form [formGroup]="secondFormGroup" class="col-md-12 " >
                    
                    <div  class="zoomI">
                      <div >
    
                    <div *ngIf="userType==='EMPLOYEE'" formArrayName="passengerDetails" >
                      <small class="color-changing-element" *ngIf="!employeeData?.firstName"> Please Update Your Profile Data!</small>
    
                      <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
                    <mat-label class="bold pt-2 pb-2">Adult {{i+1}} <span style="color: grey;">({{mapRooms('ADT',i)}})</span> </mat-label>
    
                    <mat-label>Guest name and gender</mat-label>
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Guest name</mat-label>
                      <input matInput type="text" name="name" [readonly]="!rules.InputPaxInfo"  formControlName="firstName" >
    
                    </mat-form-field> 
    
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput type="text" name="lastname" [readonly]="!rules.InputPaxInfo"  formControlName="lastName" >
    
                    </mat-form-field> 
                   
    
                    <mat-form-field class="col-md-2" appearance="outline">
                      <mat-label>Title</mat-label>
                      <mat-select matNativeControl name="gender"  formControlName="passengerTitle" >
                        <!-- <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Male</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Female</mat-option> -->
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Mr</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Mrs</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MS">Ms</mat-option>
                      </mat-select> 
                    </mat-form-field> 
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput type="text" name="email" formControlName="email" >
                      <input  type="hidden" [value]="con.value.username" formControlName="username">
      
                    </mat-form-field> 
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Mobile Number</mat-label>
                      <input matInput type="text" name="mobile" (keypress)="onlyNumberKey($event)"   formControlName="mobile">
                    </mat-form-field> 
                  <mat-form-field class=" col-md-2   " appearance="outline">
                    <mat-label>Profile Type	</mat-label>
                    <mat-select name="profile_type"  autocomplete="off" formControlName="profileType">
                      <mat-option value="">--</mat-option>
              <mat-option value="VIP">VIP</mat-option>
              <mat-option value="VVIP">VVIP/CIP</mat-option>
              </mat-select>
                  </mat-form-field>
                  <mat-divider class="mt-2 mb-1"></mat-divider>

                </div>
              
              
              </div>
                <div *ngIf="userType==='CORPORATE'||userType==='AGENT'" formArrayName="passengerDetails" >
                 
                  <div class="col-md-5"></div>
                  <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
    
                <mat-label class="bold pt-2 pb-2">Adult {{i+1}}   <span style="color: grey;">({{mapRooms('ADT',i)}})</span> </mat-label>
                <mat-form-field  *ngIf="userType!='AGENT'" class="col-md-5" appearance="outline" >
              
                  <mat-label>Select Guest {{i+1}}</mat-label>
                  <mat-chip-grid #chipGrids aria-label="city Selection">
                  </mat-chip-grid>
                  <div class="input-with-icon col-md-12">
                  <input  #travellerInput [formControl]="traveller" 
                    [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                    (matChipInputTokenEnd)="addTo($event)"
                    />
                    <mat-icon>arrow_drop_down</mat-icon>
                  </div>
    
                  <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                    <mat-option value="" *ngIf="usersList?.length===0">{{'Guest Not Found'}}</mat-option>
                    <mat-option  *ngFor="let item of filteredTo | async" [value]="item.username"  (click)="onfilterClick(item.username,con)">
                      
                      {{item?.firstName}} {{item?.lastName}}, {{item.username}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-label>Guest name and gender</mat-label>
                
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Guest name</mat-label>
                  <!--               <input matInput type="text" name="name" [readonly]="con.value.firstName===passengerDetails.controls[0].value.firstName" formControlName="firstName" >
     -->
                  <input matInput type="text" name="name" [readonly]="!rules.InputPaxInfo" formControlName="firstName" >
    
                </mat-form-field> 
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input matInput type="text" name="last" [readonly]="!rules.InputPaxInfo" formControlName="lastName" >
    
                </mat-form-field> 
               
                <mat-form-field class="col-md-2" appearance="outline">
                  <mat-label>Title</mat-label>
                  <mat-select matNativeControl name="gender" formControlName="passengerTitle" >
                    <!-- <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Male</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Female</mat-option> -->
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Mr</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Mrs</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MS">Ms</mat-option>
                  </mat-select> 
                </mat-form-field> 
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input matInput type="text" name="email" formControlName="email" >
                  <input  type="hidden" [value]="con.value.username" formControlName="username">
  
                </mat-form-field> 
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Mobile Number</mat-label>
                  <input matInput type="text" name="mobile" (keypress)="onlyNumberKey($event)"   formControlName="mobile">
                </mat-form-field> 
                <mat-form-field class=" col-md-2   " appearance="outline">
                  <mat-label>Profile Type	</mat-label>
                  <mat-select name="profile_type"  autocomplete="off" formControlName="profileType">
                    <mat-option value="">--</mat-option>
            <mat-option value="VIP">VIP</mat-option>
            <mat-option value="VVIP">VVIP/CIP</mat-option>
            </mat-select>
                </mat-form-field>
              
              <mat-divider class="mt-2 mb-1"></mat-divider>
            </div> </div>
                  <div formArrayName="passengerChild" >
                    <div *ngFor="let con of passengerChild.controls; let i=index" [formGroupName]="i" class="row">
                  <mat-label class="bold pt-2 pb-2">Child {{i+1}}  <span style="color: grey;">({{mapRooms('CHD',i)}})</span> </mat-label>
    
                  <mat-label>Guest name and gender</mat-label>
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Guest name</mat-label>
                      <input matInput type="text" name="name" formControlName="firstName" >
    
                    </mat-form-field> 
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput type="text" name="lastname"  formControlName="lastName">
    
                    </mat-form-field> 
                   
                    <mat-form-field class="col-md-2" appearance="outline">
                      <mat-label>Title</mat-label>
                      <mat-select matNativeControl name="gender" formControlName="passengerTitle">
                        <!-- <mat-option value="MR">Male</mat-option>
                        <mat-option value="MRS">Female</mat-option> -->
                        <mat-option value="MSTR">MSTR</mat-option>
                        <mat-option value="MISS">MISS</mat-option>
                      </mat-select> 
                    </mat-form-field> 
               
                  <mat-divider class="mt-2 mb-1"></mat-divider>
              </div></div>
              <div formArrayName="passengerInfent" >
                <div *ngFor="let con of passengerInfent.controls; let i=index" [formGroupName]="i" class="row">
               <mat-label class="bold pt-2 pb-2">Infant {{i+1}} <span style="color: grey;">(below 2 yrs)</span> </mat-label>
    
               <mat-label>Traveller name and gender</mat-label>
               <mat-form-field class="col-md-5" appearance="outline">
                 <mat-label>Traveller name</mat-label>
                 <input matInput type="text" name="name" formControlName="firstName" >
    
               </mat-form-field> 
               <mat-form-field class="col-md-5" appearance="outline">
                 <mat-label>Last Name</mat-label>
                 <input matInput type="text" name="lastname"  formControlName="lastName">
    
               </mat-form-field> 
              
               <mat-form-field class="col-md-2" appearance="outline">
                 <mat-label>Gender</mat-label>
                 <mat-select matNativeControl name="gender" formControlName="passengerTitle">
                   <!-- <mat-option value="MR">Male</mat-option>
                   <mat-option value="MRS">Female</mat-option> -->
                   <mat-option value="MSTR">MSTR</mat-option>
                   <mat-option value="MISS">MISS</mat-option>
                 </mat-select> 
               </mat-form-field> 
              
                <mat-divider class="mt-2 mb-1"></mat-divider>
            </div>
    
          </div>
    
    
          <div *ngIf="userType!='AGENT'" class="title" style="text-align: center;"> Reporting Details</div>
    
          <!-- <mat-form-field  class="col-md-4" appearance="outline">
            <mat-label>Billing Entity</mat-label>
            <mat-select   matNativeControl name="entity" class="required"   >
              <mat-option *ngFor="let item of DataEntity"   (click)="addBillingEntity(item)"  [value]="item?.entityName" >{{item?.entityName}} {{item?.entityGST?('('+item?.entityGST+')'):''}}</mat-option>
            </mat-select>
    
            <small  *ngIf="!billingDetail" style="color: red;">Please Select Billing Entity! </small>
          </mat-form-field>  -->

          <mat-form-field  *ngIf="userType==='CORPORATE'" class="col-md-6" appearance="outline">
            <mat-label>Billing Entity <span style="color: red;">*</span></mat-label>
            <mat-select-trigger (click)="autoBill.open()">
              <input (input)="autoBill.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEntities()" />
            </mat-select-trigger>
            <mat-select #autoBill="matSelect"  matNativeControl name="entity" required >
              <mat-option *ngFor="let item of filteredEntities"   (click)="addBillingEntity(item)"  [value]="item?.entityName" >{{item?.entityName}} {{item?.entityGST?('('+item?.entityGST+')'):''}}</mat-option>
            </mat-select>
    
            <small *ngIf="!billingDetail" style="color: red;">Please Select Billing Entity! </small>
          </mat-form-field> 
          <mat-form-field  *ngIf="userType==='EMPLOYEE'&&this.DataEntity.length>1&&!employeeData.billingEntity" class="col-md-6" appearance="outline">
            <mat-label>Billing Entity <span style="color: red;">*</span></mat-label>
            <mat-select-trigger (click)="autoBill.open()">
              <input (input)="autoBill.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEntities()" />
            </mat-select-trigger>
            <mat-select #autoBill="matSelect"  matNativeControl name="entity" required >
              <mat-option *ngFor="let item of filteredEntities"   (click)="addBillingEntity(item)"  [value]="item?.entityName" >{{item?.entityName}} {{item?.entityGST?('('+item?.entityGST+')'):''}}</mat-option>
            </mat-select>
    
            <small *ngIf="!billingDetail" style="color: red;">Please Select Billing Entity! </small>
          </mat-form-field> 
    
         
    
          <div class="   col-md-6">
            
          </div>



          <div class="col-md-6 mb-3" *ngIf="userType!='AGENT'" >


            <div  formArrayName="passengerDetails" >
              <div class="d-flex justify-content-start" style="width: 100%;overflow-y: auto;">
           
                <table *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i"  class="styled-tables "    >
                  <ng-container  *ngIf="i===0" >
                   
                  <tbody *ngIf="con.value.lastName" formArrayName="reportingTags">
          
                    <ng-container *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
                  <tr   *ngIf="tag.value['fieldType']==='F'">
                    <th *ngIf="i===0"   style="padding: 8px; text-align: start;white-space: nowrap;" [class]="tag.value.required==='C'?('form-group required'):''">
                      <label>{{tag.value.displayName}}</label>
                      </th>
                    <!-- <td> </td> -->
                    <td  style="padding: 8px; text-align: start;min-width:200px" >
                      
                      <input *ngIf="tag.value['fieldType']==='F'" type="file" [accept]="acceptedTypes" class="form-control" (change)="onFileChange($event,j,con)"  formControlName="value" >
                     <span class="file-types-msg">
    Acceptable file types: {{ acceptedTypes }}
  </span>
                    </td>
                  </tr>
                </ng-container>
                
                </tbody >
              </ng-container>
                </table>
               
          </div>
          
          </div></div>
  
  
  <div class="col-md-12" *ngIf="userType!='AGENT'" >
  
  
    <div  formArrayName="passengerDetails" >
      <div class="d-flex justify-content-start" style="width: 100%;overflow-y: auto;">
   
        <table *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i"  class="styled-tables "    >
          <ng-container  >
            <thead *ngIf="con.value.lastName" >
              <tr   >       
                <th  *ngIf="i===0"  style="min-width: 80px;"><button mat-flat-button style="background-color: #1876D1;color: #fff;" (click)="rmTagsCopy()">Copy</button></th>
                <th  ><mat-label  class="bold pt-2 pb-2"></mat-label> <button mat-flat-button style="background-color: #8fc0f1;color: #fff;margin-left: 4px;" disabled>Adult {{i+1}} </button></th>
               
              </tr>
            </thead>
          <tbody *ngIf="con.value.lastName" formArrayName="reportingTags">
  
            <ng-container *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
          <tr   *ngIf="tag.value['fieldType']!='F'">
            <th *ngIf="i===0"   style="padding: 8px; text-align: start;white-space: nowrap;" [class]="tag.value.required==='C'?('form-group required'):''">
              <label>{{tag.value.displayName}}</label>
              </th>
            <!-- <td> </td> -->
            <td  style="padding: 8px; text-align: start;min-width:300px" >
              <input *ngIf="tag.value['fieldType']==='T'" type="text" class="form-control" formControlName="value" >
              <mat-select *ngIf="tag.value['fieldType']==='D'" matNativeControl    class="form-control"   formControlName="value">
                <mat-option class="mat-primary "   *ngFor="let tagValue of tagDropDown(tag.value['checkValue'])" [value]="tagValue">{{tagValue}}</mat-option>
  
              </mat-select> 
              <!-- <input *ngIf="tag.value['fieldType']==='F'" type="file" class="form-control" (change)="onFileChange($event,j,con)"  formControlName="value" > -->
            </td>
          </tr>
        </ng-container>
        
        </tbody >
      </ng-container>
        </table>
       
  </div>
  
  </div>
  
  
  
  
  
  
         
  </div>
  <div class="col-md-10" *ngIf="false">
          <div  formArrayName="passengerDetails" >
            <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
          <mat-label *ngIf="con.value.firstName" class="bold pt-2 pb-2">Adult {{i+1}} </mat-label>
          <!-- <table class="styled-tables " >
            <thead>
              <tr >
          
              </tr>
            </thead>
            <tbody >
              <tr *ngFor="let tags of con.get('reportingTags').controls; let j = index" [formGroupName]="j">
                <th style="padding: 8px;  text-align: start;" [class]="tags.required==='C'?('form-group required'):''"><label for="" class="">{{tags.displayName}}</label></th>
                <td style="padding: 8px;  text-align: start;" *ngIf="tags.tagValue['show to admin']==='Y'&&!tags.tagFixedValue.includes(':')"><input  type="text" class="form-control"  formControlName="tags.value"></td>
                <td style="padding: 8px;  text-align: start;" *ngIf="tags.tagValue['show to admin']==='Y'&&tags.tagFixedValue.includes(':')"><input  type="text" class="form-control"  [formControlName]="tags.tagFixedValue.split(':')[1]"></td>
  
                </tr>
              </tbody>
              
              </table> -->
              <!-- <table *ngIf="con.value.firstName" class="styled-tables " >
                <tbody formArrayName="reportingTags">
  
                <tr  *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
                  <th style="padding: 8px; text-align: start;" [class]="tag.value.required==='C'?('form-group required'):''">
                    <label>{{tag.value.displayName}}</label>
                  </th>
                  <td style="padding: 8px; text-align: start;">
                    <input type="text" class="form-control" formControlName="value" >
                  </td>
                </tr>
                <tbody >
  
              </table> -->

              <table *ngIf="con.value.firstName" class="styled-tables " >
                <tbody formArrayName="reportingTags">
  
                <tr  *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
                  <th style="padding: 8px; text-align: start;" [class]="tag.value.required==='C'?('form-group required'):''">
                    <label>{{tag.value.displayName}}</label>
                  </th>
                  <td style="padding: 8px; text-align: start;">
                    <input *ngIf="tag.value['fieldType']==='T'" type="text" class="form-control" formControlName="value" >
                    <!-- <input  type="text" class="form-control" formControlName="value" > -->
                    <mat-select *ngIf="tag.value['fieldType']==='D'" matNativeControl    class="form-control"   formControlName="value">
                      <mat-option class="mat-primary "   *ngFor="let tagValue of tagDropDown(tag.value['checkValue'])" [value]="tagValue">{{tagValue}}</mat-option>
       
                    </mat-select> 
                    <input *ngIf="tag.value['fieldType']==='F'" type="file" class="form-control" (change)="onFileChange($event,j,con)"  formControlName="value" >
  
  
                  </td>
                </tr>
                <tbody >
  
              </table>
              <!-- <table class="styled-tables " >
                <tbody >
  
                <tr  *ngFor="let tag of con.value.reportingTags; let j = index" >
                  <th style="padding: 8px; text-align: start;" [class]="tag.required==='C'?('form-group required'):''">
                    <label>{{tag.displayName}}</label>
                  </th>
                  <td style="padding: 8px; text-align: start;">
                    <input type="text" class="form-control" [(ngModel)]="tag.value" [ngModelOptions]="{standalone: true}">
                  </td>
                </tr>
                </tbody>
              </table> -->
        </div>
        
      </div>
      
      
    
  
  </div>
      
  
          </div>
        </div>
                </form>
                
                <mat-divider class="mt-2 mb-1"></mat-divider>
    
                  <div class="mt-2" (click)="RequiredPopup()">
                    <button mat-raised-button color="accent" matStepperNext (click)="PassengerDetails()">Continue</button>
                    <!-- <button mat-button (click)="stepper.reset()">Reset</button> -->
                  </div>
                  
                </mat-step>
                <mat-step [stepControl]="secondNextFormGroup" >
                  <form [formGroup]="secondNextFormGroup" class="row">
                    <ng-template matStepLabel>Special Request</ng-template>
                    
                    <mat-form-field class="col-md-6" appearance="outline">
                      <mat-label>Special Request</mat-label>
                      <mat-select 
                        multiple 
                        matNativeControl 
                        name="specialRequest" 
                        formControlName="specialRequest"
                        (selectionChange)="onSpecialRequestChange($event)">
                        <mat-option value="Smoking room">Smoking room</mat-option>
                        <mat-option value="Room on higher floor">Room on higher floor</mat-option>
                        <mat-option value="Room on Ground floor">Room on Ground floor</mat-option>
                        <mat-option value="Early Check in">Early Check in</mat-option>
                        <mat-option value="Late check out">Late check out</mat-option>

                        <mat-option value="Others">Others</mat-option>
                      </mat-select>
                    </mat-form-field>
                    
                    <!-- Display input field when 'Others' is selected -->
                    <div *ngIf="showOthersField" >
                      <mat-form-field class="col-md-6" appearance="outline">
                        <mat-label>Please specify (Others)</mat-label>
                        <input matInput placeholder="Enter your request" formControlName="otherRequest" />
                      </mat-form-field>
                    </div>
                    <div *ngIf="showEarlyCheckin" >
                      
                      <mat-form-field class="col-md-6  " appearance="outline">
                        <mat-label>Early Check in</mat-label>
                          <mat-hint>MM/DD/YYYY</mat-hint>
                        <input matInput [ngxMatDatetimePicker]="pick" readonly placeholder="Choose a date" formControlName="earlyCheckin"
                           >
                        <button mat-icon-button matSuffix (click)="pick.open()">
                          <mat-icon>calendar_today</mat-icon>
                        </button> 
                        <ngx-mat-datetime-picker #pick [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                          [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                          [disableMinute]="disableMinute" [hideTime]="hideTime">
                        </ngx-mat-datetime-picker> 
                      </mat-form-field>
                    </div>
                    <div *ngIf="showLateCheckOut" >
                      <!-- <mat-form-field class="col-md-6" appearance="outline">
                        <mat-label>Late check out</mat-label>
                        <input matInput placeholder="Enter your request" formControlName="lateCheckOut" />
                      </mat-form-field> -->

                      <mat-form-field class="col-md-6  " appearance="outline">
                        <mat-label>Late check out</mat-label>
                          <mat-hint>MM/DD/YYYY</mat-hint>
                        <input matInput [ngxMatDatetimePicker]="picker" readonly placeholder="Choose a date" formControlName="lateCheckOut"
                           >
                        <button mat-icon-button matSuffix (click)="picker.open()">
                          <mat-icon>calendar_today</mat-icon>
                        </button> 
                        <ngx-mat-datetime-picker #picker [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                          [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond"
                          [touchUi]="touchUi" [color]="color" [enableMeridian]="enableMeridian" 
                          [disableMinute]="disableMinute" [hideTime]="hideTime">
                        </ngx-mat-datetime-picker> 
                      </mat-form-field>
                    </div>
                    <ul>
                      <strong>Disclaimer :</strong>
                      <li style="color: rgb(168, 157, 5);">
                      Special requests are at the discretion of the hotel and subject to availability.
Please contact our Customer Support if you&#39;d like to add guaranteed services.
                    </li></ul>
                    <mat-divider class="mt-2"></mat-divider>
  
                    <div class="mt-2">
                      <button mat-raised-button color="accent" matStepperNext (click)="onClickSpecialReq()">Continue</button>
                    </div>
                  </form>
                </mat-step>
                <mat-step [stepControl]="thirdFormGroup" >
                    <form [formGroup]="thirdFormGroup" class="row">
                      <ng-template matStepLabel>Add contact details</ng-template>
                      
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Mobile Number</mat-label>
                        <input matInput type="tel" name="mobile" (keypress)="onlyNumberKey($event)"  formControlName="mobileCtrl">
                        <small *ngIf="thirdFormGroup.controls['mobileCtrl'].dirty && thirdFormGroup.controls['mobileCtrl'].invalid" class="warn">Please enter Mobile Number!</small>
    
                      </mat-form-field> 
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" name="email" formControlName="emailCtrl">
                        <small *ngIf="thirdFormGroup.controls['emailCtrl'].dirty && thirdFormGroup.controls['emailCtrl'].invalid" class="warn">Please enter Email Address!</small>
    
                      </mat-form-field> 
                      <mat-divider class="mt-2"></mat-divider>
    
                      <div class="mt-2">
                        <button mat-raised-button color="accent" matStepperNext>Continue</button>
                      </div>
                    </form>
                  </mat-step>
                  <mat-step [stepControl]="fourthFormGroup" >
                    <form [formGroup]="fourthFormGroup" class="col-md-12 row" >
                      <ng-template matStepLabel >Review</ng-template>
                      <!--<ng-template matStepLabel *ngIf="seats.length===0"> Continue to payment</ng-template>-->
    
    
                      <!-- <div class="tabs-container" >
                        <button  class="" mat-icon-button class="arrow arrow-left" (click)="scrollTabs('left')">
                          <mat-icon>keyboard_arrow_left</mat-icon>
                        </button>
                        <div class="tabs tabButton" #tabsRef>
                          <div class="tab" *ngFor="let tab of item.tag" [class.active]="tab.active">{{ tab.meal_desc }}</div>
                        </div>
                        <button class="" mat-icon-button class="arrow arrow-right" (click)="scrollTabs('right')">
                          <mat-icon>keyboard_arrow_right</mat-icon>
                        </button>
                      </div> -->
                      
    
    
                      <div class="col-md-12 mt-3" >
                        
                        <!-- <table class="styled-tables ">
                            <thead>
                              <tr >
                                <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> hotel</mat-icon>Room Type
                                </th>
                                <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Meal Plan</th>
                                <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> groups</mat-icon>Guest Name  </th>
                                
    
    
                              </tr>
                            </thead>
                            <tbody *ngFor="let room of searchDetail.rooms; let j=index">
    
    
                              <tr *ngFor="let con of travellerDetails; let i=index">
                                <td class=""style="padding: 8px;  text-align: center;" >
                              
                                  {{seatPagination?.selectedHotelOrder?.hotel?.mmtRooms[0]?.name}}
                                </td>
                                   <td class=""style="padding: 8px;  text-align: center;" >
                                    
                                      {{seatPagination?.selectedHotelOrder?.hotel?.mmtRooms[0]?.ratePlans[0]?.description}}
                                     </td>
                                <td class=""style="padding: 8px;  text-align: center;" >
                               {{con?.passengerTitle}}  {{con?.firstName}}  {{con?.lastName}} <br>
                               {{con.passengerType==="ADT"?("Adult"):con.passengerType==="CHD"?("Child"):con.passengerType==="INF"?("Infant"):''}} {{i+1}}
                                </td>
                                
  
                           
    
                              </tr>
                            </tbody>
                          </table> -->
                          <table class="styled-tables">
                            <thead>
                              <tr>
                                <th style="padding: 8px; text-align: center;">
                                  <mat-icon class="pt-1" style="margin-right: 2px;">hotel</mat-icon>Room Type
                                </th>
                                <th *ngIf="source==='mmt'" style="padding: 8px; text-align: center;">
                                  <mat-icon class="pt-1" style="margin-right: 2px;">restaurant</mat-icon>Meal Plan
                                </th>
                                <th *ngIf="source==='expedia'" style="padding: 8px; text-align: center;">
                                  <mat-icon class="pt-1" style="margin-right: 2px;">restaurant</mat-icon>Services
                                </th>
                                <th style="padding: 8px; text-align: center;">
                                  <mat-icon class="pt-1" style="margin-right: 2px;">groups</mat-icon>Guest Name
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let room of mergedData">
                                <td style="padding: 8px; text-align: center;">
                                  {{ room.roomType }}
                                </td>
                                <td *ngIf="source==='mmt'" style="padding: 8px; text-align: center;">
                                  {{ room.mealPlan }}
                                </td>
                                <td *ngIf="source==='expedia'">
                                  <ul style="text-align: start;" >
                                    <!-- style="list-style: none;" -->
                                  <li  *ngFor="let amen of  seatPagination?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0].amenities let t = index"  [hidden]=" t >= 2"> 
                                    <!-- <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free WiFi'">wifi</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free self parking'"> local_parking</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Breakfast buffet'">free_breakfast</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top:8px;" *ngIf="amen.name==='Free one-way airport transfer'"> transfer_within_a_station</mat-icon>
                                    <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Free welcome drink'"> local_drink</mat-icon>
             -->
                                    {{ amen.name }}
            
                                  </li>
                                  <li style="list-style: none;" *ngIf="seatPagination?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0]?.amenities&&seatPagination?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0]?.amenities.length>2"><span  class="yes" style="cursor: pointer;" (click)="ameni.toggle($event)">...more</span></li>
            
                                  <p-overlayPanel #ameni [style]="{ width: '30rem' }">
                                    <li *ngFor="let amen of seatPagination?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0].amenities "  > 
                                      {{ amen.name }}
                                    </li>
                                  </p-overlayPanel>

                                  </ul>
                                </td>
                                <td style="padding: 8px; text-align: center;">
                                  <div *ngFor="let guest of room.guests.assignedAdults">
                                    {{ guest}} <br>
                                    {{'Adult'}}
                                    <mat-divider ></mat-divider>
                                  </div>
                                  
                                  <div *ngFor="let guest of room.guests.assignedChildren">
                                    {{ guest.name }}  <br>
                                    {{'Child'}} <small>({{ guest.age }} Year Old )</small>
                                    <mat-divider></mat-divider>

                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          
    
                </div> 
    
    
    
                 
                    
                      <mat-divider class="mt-2"></mat-divider>
                      <!-- <mat-checkbox   
                      (change)="onCheckboxChange($event)"
        
                      click="acknowledge=!acknowledge" [color]="'primary'" >
                      I acknowledge that I am booking the aforesaid room type and meal plan for my guest(s).
                    </mat-checkbox> -->





                      <div class="mt-2" *ngIf="tripEnable===false">
                        <!-- bookflight() -->
                        <button *ngIf="!swingOrderId" mat-raised-button color="accent" style="margin-right: 2%; width: 300px;" (click)="orderIds()" [disabled]="acknowledge">View and Payment to Continue</button>
                        <button  *ngIf="swingOrderId"  mat-raised-button color="accent" style="margin-right: 2%; width: 300px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                      </div>
                      <div class="mt-2" *ngIf="tripEnable===true">
                        <!-- bookflight() -->
                        <button *ngIf="!swingOrderId" mat-raised-button color="accent" style="margin-right: 2%; width: 300px;" (click)="orderIds()" [disabled]="acknowledge"> Continue</button>
                        <button  *ngIf="swingOrderId"  mat-raised-button color="accent" style="margin-right: 2%; width: 300px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                      </div> 
                    </form>
                  </mat-step>
              </mat-stepper>
            </div>
            <div *ngIf="paymentDetail "  [class]="showSideBar?('col-md-12'):'col-md-9'">
            
              <app-hotel-payment-detail (myOutput)="backClick()"  (hideSideBar)="hideSideBar()"></app-hotel-payment-detail>
    
            </div>
             <!-- <div *ngIf="paymentDetail && showSideBar" class="col-md-12 ">
            
              <app-payment-details (myOutput)="backClick()"  (hideSideBar)="hideSideBar()"></app-payment-details>
    
            </div> -->
            <div  *ngIf="!showSideBar" class="col-md-3" style="background-color: #d2e1f5; border-radius: 4px; content: right; height: 85vh; overflow-y: auto;">
    
    
              <!-- trip-details.component.html -->
    
    <div class="trip-details-container">
    
      <!-- (click)="togglePanel('advancePrice')" -->
      <div *ngIf="hideAdvancePricing&&loginUserType==='STAFF'" class="panel mt-3" >
        <div  class="flex flex-middle flex-between row pt-1 " style="background-color: #1876D1; border-radius: 4px; min-height:30px ;color:white" >
         <div class="col-md-12 input-with-icon" (click)="OnSidebarClick()">
          <span class="fs-5 col-md-6  ">
            <div  class="col-md-12 d-flex justify-content-start bold" style="font-size: 18px;"> 
               Advanced Pricing
            </div>
          </span>
    
          <mat-icon style="font-size: 18px;">open_with</mat-icon>
        </div>
       
        </div> 
      
       
      
      </div>
    
    
    
    
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    
      <div class="panel mt-1" >
        <div (click)="togglePanel('totalPrice')" class="flex flex-middle flex-between row pt-2 " style="background-color: #1876D1; border-radius: 4px; min-height:50px ;color:white" >
         <div class="col-md-12 input-with-icon">
          <span *ngIf="source==='mmt'" class="fs-5 col-md-6  ">Total price</span>
          <span *ngIf="source==='expedia'&&repriceData[0]?.sale_scenario?.package===true" class="fs-5 col-md-6  ">Package price</span>
          <span *ngIf="source==='expedia'&&repriceData[0]?.sale_scenario?.package===false" class="fs-5 col-md-6  ">Total price</span>


          <!-- <span class="col-md-6 spanTotal pb-1 pt-1">{{repriceData[0]?.totalAmount+repriceData[0]?.price?.totalTax}} INR</span> -->

          <span *ngIf="source==='mmt'" class="col-md-6 spanTotal pb-1 pt-1">{{(repriceData[0]?.totalAmount+advanceTotal)?.toFixed()||0}} INR</span>
          <span *ngIf="source==='expedia'" class="col-md-6 spanTotal pb-1 pt-1">
          {{(repriceData[0]?.totalPrice?.requestedCurrencyTotalPrice+advanceTotal)?.toFixed()||0}}&nbsp;INR
          </span>
          <mat-icon *ngIf="expandedPanel === 'totalPrice'">keyboard_arrow_up</mat-icon>
    
          <mat-icon *ngIf="expandedPanel != 'totalPrice'">keyboard_arrow_down</mat-icon>
        </div>
        </div>    <div *ngIf="expandedPanel === 'totalPrice'" class="panel-content">
          <div *ngIf="source==='expedia'" class="col-md-12">
            <div class="flexflex-between flex-row"></div>
           
            <!-- *ngIf="orderboolean" -->
            <div   class="mt-2 row"  style="font-size: 12px; ">
              <span class="col-md-8 pt-1">Base Fare </span>
    
              <span class="col-md-4 pb-1 pt-1">{{repriceData[0]?.totalPrice?.exclusive?.request_currency?.value?.toFixed()}}&nbsp;{{repriceData[0]?.totalPrice?.exclusive?.request_currency?.currency||'INR'}}</span>
               <mat-divider></mat-divider>
               <span class="col-md-8 pt-1">Taxes & fees</span>
    
              <span class="col-md-4 pb-1 pt-1" style="white-space: nowrap;">{{(repriceData[0]?.totalPrice?.inclusive?.request_currency?.value-repriceData[0]?.totalPrice?.exclusive?.request_currency?.value)?.toFixed()||0}} &nbsp;{{repriceData[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}}&nbsp;<mat-icon style="cursor: pointer;color:grey;padding-top: 8px;font-size: 18px;" (click)="text.toggle($event)">info</mat-icon></span>
              <p-overlayPanel #text [style]="{ width: '30rem' }">
                <div class="flex flex-column gap-3 w-25rem">

                  This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked. For more details, please see the <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank"> terms and conditions.</a>
                </div>
                  </p-overlayPanel>
               <mat-divider></mat-divider>
               <span class="col-md-8 pt-1">property Fee</span>
    
              <span class="col-md-4 pb-1 pt-1">{{repriceData[0]?.totalPrice?.property_fees?.request_currency?.value?.toFixed()||0}}&nbsp;{{repriceData[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}}</span>
               <mat-divider></mat-divider>
               <span class="col-md-8 pt-1">Affiliate Service Charge + GST</span>

               <span class="col-md-4 pb-1 pt-1">{{repriceData[0]?.commercial?.charge?(repriceData[0]?.commercial?.charge?.toFixed()):0}} + {{repriceData[0]?.commercial?.tax?(repriceData[0]?.commercial?.tax?.toFixed()):0}} INR</span>
               <mat-divider></mat-divider>

               <span *ngIf="loginUserType==='STAFF'" class="col-md-8  bold pt-1" style="color:#44a2f7;cursor: pointer;" >Advanced Pricing</span>
              <span *ngIf="loginUserType==='STAFF'" class="col-md-4 pb-1 pt-1" >{{advanceTotal}} INR</span>

               <mat-divider style="background-color: #1876D1;"></mat-divider>

               <span class="col-md-8 pt-1 bold">Total Price ({{travellerDetail?.adult+travellerDetail?.child}} {{travellerS}})</span>
    
              <span class="col-md-4 pb-1 pt-1 bold" >{{(repriceData[0]?.totalPrice?.requestedCurrencyTotalPrice+advanceTotal)?.toFixed()||0}}&nbsp;INR</span>
               <!-- <mat-divider style="background-color: #1876D1;"></mat-divider> -->
               </div>
               </div>
          
          <div *ngIf="source==='mmt'" class="col-md-12">
            <div class="flexflex-between flex-row"></div>
           
            <!-- *ngIf="orderboolean" -->
            <div   class="mt-2 row"  style="font-size: 12px; ">
              <span class="col-md-8 pt-1">Base Fare</span>
    
              <span class="col-md-4 pb-1 pt-1">{{mmtBaseFare(repriceData[0]?.price?.basePrice,repriceData[0]?.price?.couponDiscount,repriceData[0]?.price?.hotelDiscount)||0}}&nbsp;INR</span>
              <mat-divider></mat-divider>
              <span class="col-md-8 pt-1">Taxes & fees</span>
    
              <span class="col-md-4 pb-1 pt-1">{{repriceData[0]?.price?.totalTax||0}}&nbsp;INR</span>
              
              <mat-divider></mat-divider>
              <span class="col-md-8 pt-1">MGMT FEE + GST</span>

              <span class="col-md-4 pb-1 pt-1">{{repriceData[0]?.commercial?.charge?(repriceData[0]?.commercial?.charge?.toFixed()):0}} + {{repriceData[0]?.commercial?.tax?(repriceData[0]?.commercial?.tax?.toFixed()):0}} INR</span>
              <mat-divider></mat-divider>

              <span *ngIf="loginUserType==='STAFF'" class="col-md-8  bold pt-1" style="color:#44a2f7;cursor: pointer;" >Advanced Pricing</span>
              <span *ngIf="loginUserType==='STAFF'" class="col-md-4 pb-1 pt-1" >{{advanceTotal}} INR</span>

              <mat-divider style="background-color: #1876D1;"></mat-divider>

              <span class="col-md-8 pt-1">Total Price ({{travellerDetail?.adult+travellerDetail?.child}} {{travellerS}})</span>
    
              <span class="col-md-4 pb-1 pt-1">{{repriceData[0]?.totalAmount+advanceTotal}} INR</span>
             
            </div>
    
          </div>
        </div>
      </div>
    
    <!--+++++++++++++++++++++++++++++++++++ hotel Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ hotel Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ hotel Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ hotel Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ hotel Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ hotel Details ++++++++++++++++++++++++++-->
    
   
      <div class="panel mt-3" *ngIf="flights" (click)="togglePanel('itinerary')">
        
    
       
      
        
      </div>
    
    
   
  
  
  
  
      
    </div>
    
               
              </div>
            </div>
    
            </div>
          </div>
        </div>
      </div>
           
              
    
      
    <p-sidebar [(visible)]="showSidebar" position="left" styleClass="col-md-8" >
      <ng-template pTemplate="header">
        <strong class="col-md-11 font-semibold text-xl">Advanced Pricing</strong>
          
        <!-- pTemplate="headless" -->
      
    </ng-template>
    <span  >
      
     
    <table   class="styled-tables col-md-12" >
      <thead>
        <tr >
          <!-- <th style="padding: 8px;  text-align: center;">Base   </th>
          <th style="padding: 8px;  text-align: center;">Tax  </th>
          <th style="padding: 8px;  text-align: center;">Fee  </th> -->
  
  
  
        </tr>
      </thead>
      
       
      <tbody  *ngFor="let traveller of travellerArray(searchDetail?.roomCount);let i=index" >
        <!-- <tr >
          <td class="value-cell"><strong>Room {{i+1}}</strong> </td>
          <td class="value-cell"></td>
          <td class="value-cell"></td>
          </tr> -->
        <tr >
          <th style="padding: 8px;  text-align: center;">Additional Charges   </th>

          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event,'baseAmt', i)"  [ngModel]="this.advancedPricingDataList[0]?.advancedPricingList[0]?.baseAmt"  type="text" (keypress)="onlyNumberKey($event)"></td>
          <!-- <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event,  'taxAmt', i)" readonly ngModel="0" type="text" (keypress)="onlyNumberKey($event)"></td>
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event,  'feeAmt', i)"  readonly ngModel="0" type="text" (keypress)="onlyNumberKey($event)"></td>
         -->
        
  
        </tr>
      </tbody>
  
      
  
    </table>
    <br>
    </span>
    <ng-template pTemplate="footer">
      <div class=" d-flex justify-content-end">
    <span class="bold " style="margin-right:10px ;font-size: 23px;">Total Price : {{advanceTotal}} INR </span>
  <button mat-flat-button style="color: white;background-color: #1876D0;" (click)="submit()">Close</button>
    </div>
   </ng-template>
  </p-sidebar>
    
            
              
    
    
        
    